import { Index, MusicBots, ManageServer, Settings, SignIn, TsManagerBots, Users } from "./pages"
import RankSystems from "./pages/RankSystems"
import ProtectedRoute from "./components/ProtectedRoute"

import { APP_ROUTES } from "./utils/constants"
import BannerBots from "./pages/BannerBots"
import Jts3Users from "./pages/Jts3Users"

const routes = [
    {
        path: APP_ROUTES.INDEX,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <Index />
                </ProtectedRoute>
            </div>
        ),
    },
    {
        path: APP_ROUTES.MUSIC_BOTS,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <MusicBots />
                </ProtectedRoute>
            </div>
        ),
    },
    {
        path: APP_ROUTES.MANAGE_SERVER,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <ManageServer />
                </ProtectedRoute>
            </div>
        ),
    },
    {
        path: APP_ROUTES.SETTINGS,
        element: (
            <div className="settings-container">
                <ProtectedRoute>
                    <Settings />
                </ProtectedRoute>
            </div>
        ),
    },
    { path: APP_ROUTES.SIGN_IN, element: <SignIn /> },
    {
        path: APP_ROUTES.TS_MANAGER_BOTS,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <TsManagerBots />
                </ProtectedRoute>
            </div>
        ),
    },
    {
        path: APP_ROUTES.USERS,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <Users />
                </ProtectedRoute>{" "}
            </div>
        ),
    },
    {
        path: APP_ROUTES.RANKSYSTEMS,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <RankSystems />
                </ProtectedRoute>{" "}
            </div>
        ),
    },
    {
        path: APP_ROUTES.JTS3_USERS,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <Jts3Users />
                </ProtectedRoute>{" "}
            </div>
        ),
    },
    {
        path: APP_ROUTES.BANNER_BOTS,
        element: (
            <div className="crud-container">
                <ProtectedRoute>
                    <BannerBots />
                </ProtectedRoute>
            </div>
        ),
    },
]

export default routes
